/// <summary>
/// 统计相关API入口
/// </summary>
/// <author>xiexingwu</author>
import KitLog from "@/Fwk/Kit/KitLog";
import KitAPI from "../KitAPI";
import {KitConst} from "@/Fwk/Kit/KitConst";
import KitCfg from "../KitCfg";
import {ITask} from "./ITask";
import {TimerTask} from "./TimerTask";
import {KitEvent} from "./KitEvent";
import {TrackLifecycle} from "./TrackLifecycle";
import {UploadManger} from "./UploadManger";
import {KitAdjust} from "../Adjust/KitAdjust";
import {JsonData} from "@/Fwk/Kit/JsonData";
import {EventName, RecodeKey} from "@/Fwk/Kit/Track/TrackConst";

export class KitTrack {
    static LOG_TAG = "[Track]";

    static SRC_TYPE_NOW = 1;
    static SRC_TYPE_COM = 2;
    static SRC_TYPE_DELAY = 3;

    public static readonly _task: ITask = new TimerTask();

    public static Init() {
        TrackLifecycle.Init();
        this.TrackALive(EventName.ALIVE_INIT);
        //这里是Unity主线程,获取
        this.InitBaseJson();
        UploadManger.Start();
    }

    static Log(msg: string) {
        KitLog.Log(this.LOG_TAG, msg);
    }

    static LogW(msg: string) {
        KitLog.LogWarning(this.LOG_TAG, msg);
    }

    private static baseJson: JsonData;

    private static InitBaseJson() {
        this.baseJson = new JsonData();
        //sdk的版本号
        this.baseJson.put(RecodeKey.COUNTRY, KitAPI.country);
        this.baseJson.put(RecodeKey.OS_LANGUAGE, KitAPI.language);
        this.baseJson.put(RecodeKey.SDK_CHANNEL_VERSION, "1.0");
        // this.baseJson.put(RecodeKey.INSTALL_SOURCE, KitAPI.installer);//安装方式
        this.baseJson.put(RecodeKey.STATICS_SDK_VERSION, KitConst.KIT_VERSION_NAME);
        this.baseJson.put(RecodeKey.BSM_VERSION_CODE, KitConst.KIT_VERSION_CODE);
        this.baseJson.put(RecodeKey.BSM_VERSION_NAME, KitConst.KIT_VERSION_NAME);
        this.baseJson.put(RecodeKey.OS_VERSION, KitAPI.osVersion);
        this.baseJson.put(RecodeKey.PRODUCT_ID, KitCfg.productId);
        this.baseJson.put(RecodeKey.RELEASE_PRODUCT_ID, KitCfg.releaseProductId);
        this.baseJson.put(RecodeKey.PACKAGE_NAME, KitAPI.packageName);
        this.baseJson.put(RecodeKey.BSM_TYPE, KitConst.BASEMENT_TYPE);
        this.baseJson.put(RecodeKey.UUID_ID, KitAPI.UUID);
        this.baseJson.put(RecodeKey.PHONE_MODEL, KitAPI.deviceType);
        // this.baseJson.put(RecodeKey.SCREEN_WH, $"{Screen.height}x{Screen.width}");
        this.baseJson.put(RecodeKey.OS, KitAPI.osIntType);
        // this.baseJson.put(RecodeKey.SCREEN_INCHU, Screen.INCHU);//暂时不做
        this.baseJson.put(RecodeKey.DPI, KitAPI.dpi);
        this.baseJson.put(RecodeKey.H5_HOST_NAME, KitAPI.WebHotName);
        this.baseJson.put(RecodeKey.H5_CHANNEL_QID, KitAdjust.h5ChannelQid);
    }

    static MergeBase(json: JsonData) {
        // 遍历 obj2 的所有键值对并添加到 obj1
        const keys = Object.keys(this.baseJson.jObject);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            json.put(key, this.baseJson.jObject[key]);
        }

        // if (KitAPI.IS_IOS) json.put(RecodeKey.IFA, KitAPI.ADID);
        json.put(RecodeKey.GOOGLE_AID, KitAPI.ADID);
        json.put(RecodeKey.TP_DEVICE_ID, KitAPI.GetSmID());
        json.put(RecodeKey.MEDIA_SOURCE, KitAdjust.GetDistributor(false));
        json.put(RecodeKey.CAMPAIGN, KitAdjust.GetSecondDistributor());
        json.put(RecodeKey.ADSET_ADSET_ID, KitAdjust.GetCreative());
        json.put(RecodeKey.ADGROUP_NAME, KitAdjust.GetAdGroup());
    }

    static TrackALive(key: string) {
        KitEvent.track112(key)
            .Put(RecodeKey.ATTRIBUTION_ID, KitAdjust.GetAdjustAdid())
            .Commit();
        // KitAPI.GoogleGTMEvent(key, "");
    }
}
